import BaseComponent from "../../../baseComponent.js";
import TableWidget from "../../widgets/table/tableWidget.jsx";

export default class Table extends BaseComponent {
  constructor(props) {
    super(props);
  }
  render () {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    return (
      <TableWidget widgetId={this.props.model.id}
                   legends={this.props.model.legends}
                   componentId={component.controller.id}
                   openSideNav={this.props.openSideNav}
                   isAddWidget={this.props.isAddWidget}
                   isPreviewWidget={this.props.isPreviewWidget}
                   dataProfile={this.props.dataProfile}
                   dataset={this.props.dataset}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/table.jsx